import React from "react";
import { COMPANY } from "@/lib/company";

// variant "onDark" = original light logo (video hero, footer); "onLight" = anthracite version for light surfaces.
export const Logo = ({ className = "h-10", testId = "brand-logo", variant = "onLight" }) => {
  const src = variant === "onLight" && COMPANY.logoDark ? COMPANY.logoDark : COMPANY.logo;
  return src ? (
    <img src={src} alt={COMPANY.legalName} data-testid={testId} data-variant={variant}
      className={`${className} w-auto object-contain select-none`} draggable={false} />
  ) : (
    <span data-testid={testId} className="font-display font-bold text-xl tracking-tight">{COMPANY.name}</span>
  );
};

export const Pending = ({ children = "Angabe folgt", testId }) => (
  <span data-testid={testId}
    className="inline-flex items-center gap-1.5 border border-dashed border-silver/60 text-faint rounded-md px-2 py-0.5 text-[11px] uppercase tracking-wider align-middle">
    {children}
  </span>
);

export default Logo;
